import { IconProps } from "@/components/shared/Icon"
import { AlertThreshold, ProcessingMethod } from "@/types/alert"

export interface VitalDisplayItem {
   iconName: IconProps["name"]
   arrowIcon: "lowerThreshold" | "upperThreshold"
   thresholdValue: number
   thresholdProcessingMethod: ProcessingMethod
}

export const getLevelIcon = (type: string): IconProps["name"] => {
   switch (type.toLowerCase()) {
      case "building":
         return "building"
      case "block":
         return "block"
      default:
         return "floor"
   }
}

export const getVitalItem = (
   iconName: IconProps["name"],
   low: boolean | undefined,
   high: boolean | undefined,
   threshold: AlertThreshold
): VitalDisplayItem | null => {
   if (!low && !high) return null
   return {
      iconName,
      arrowIcon: low ? "lowerThreshold" : "upperThreshold",
      thresholdValue: low ? threshold.low : threshold.high,
      thresholdProcessingMethod: threshold.processingMethod,
   }
}

export const filterVitalItems = (
   items: (VitalDisplayItem | null)[]
): VitalDisplayItem[] => items.flatMap((item) => (item ? [item] : []))

export const groupLevelsByType = (
   levels: { name: string; type: string }[]
): Record<string, string[]> =>
   levels.reduce<Record<string, string[]>>((acc, level) => {
      const key = level.type
      acc[key] = [...(acc[key] ?? []), level.name]
      return acc
   }, {})
